/**
 * Utilidades para sanitização de dados contra XSS
 */
import DOMPurify from 'dompurify';

/**
 * Sanitiza string simples para prevenir XSS
 * @param {string} input - String a ser sanitizada
 * @returns {string} String segura
 */
export function sanitizeText(input) {
  if (!input || typeof input !== 'string') {
    return input;
  }
  
  // Configuração rigorosa: apenas texto, sem HTML
  return DOMPurify.sanitize(input, { 
    ALLOWED_TAGS: [], 
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true 
  });
}

/**
 * Sanitiza dados de item de planilha
 * @param {Object} item - Item de dados
 * @returns {Object} Item com dados sanitizados
 */
export function sanitizeDataItem(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const sanitizedItem = {};
  
  // Campos que precisam de sanitização
  const textFields = [
    'ID', 'Nome', 'nome', 'Tipo de Item', 'Status', 'Descrição',
    'Data de Inicio', 'Previsão de Entrega', 'Data de Conclusão'
  ];
  
  // Copiar todos os campos, sanitizando os de texto
  for (const [key, value] of Object.entries(item)) {
    if (textFields.includes(key) && typeof value === 'string') {
      sanitizedItem[key] = sanitizeText(value);
    } else {
      sanitizedItem[key] = value;
    }
  }
  
  return sanitizedItem;
}

/**
 * Sanitiza array de dados
 * @param {Array} data - Array de dados
 * @returns {Array} Array com dados sanitizados
 */
export function sanitizeDataArray(data) {
  if (!Array.isArray(data)) {
    return data;
  }
  
  return data.map(item => sanitizeDataItem(item));
}

/**
 * Hook para sanitização automática de dados
 * @param {Array} rawData - Dados brutos
 * @returns {Array} Dados sanitizados
 */
export function useSanitizedData(rawData) {
  return sanitizeDataArray(rawData);
}
